// extracted by mini-css-extract-plugin
export default {"outerWrapper":"styles_outerWrapper__8U9OL","innerWrapper":"styles_innerWrapper__gIyLK"};